// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 25px;
  margin-bottom: 5px;
  text-align: center;
}

.subHeading {
  text-align: center;
  color: #8a8a8a;
}

.shadow {
  width: 160px;
}

.fontweight600 {
  font-weight: 600;
}

.header2 .block-limiter {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}

.header2 .brandhotelselector {
  margin-top: 5px;
}

.bellContainer {
  position: relative;
  width: 50px;
}

.floatRight {
  float: right;
}

.marginBottom20 {
  margin-bottom: 20px;
}

.calender-selection {
  margin-top: 5px;
}

.calender-selection .control-select-men {
  display: inline-block;
  float: left;
}

.calender-selection .control-select-filter-men {
  display: inline-block;
  float: left;
}

.displayInline {
  display: inline !important;
}

.stdcontainer .block-limiter {
  padding: 0 10px 10px 10px;
}

.fullWidthSelect {
  width: 100% !important;
}

.shadow {
  width: 160px;
}

.noShadow {
  box-shadow: none;
}

.tagsContainer {
  float: left;
}

.iconsContainer {
  float: left;
}

.iconsContainer svg {
  height: 20px !important;
  width: 20px !important;
  margin-right: 10px;
}

.stdIconContainer {
  margin-top: 10px;
}

.tagsContainer .tags-tag {
  background-color: #FFF;
  border: 1px solid #d1dbec;
}

.stdIconContainer svg {
  margin-right: 15px;
}

.tabContainer .tabContent {
  display: none;
}

.tabContainer .active {
  display: block;
}

.tabs {
  width: 100%;
}

.tabs .tabs-ul {
  list-style: none;
  padding-bottom: 12px;
  margin-bottom: 0px;
  display: inline-block;
  border-bottom: 1px solid #F1F1F1;
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
  white-space: nowrap;
}

.tabs .tabs-ul li {
  display: inline;
  margin-right: 10px;
  color: #919191;
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 10px;
}

.tabs .tabs-ul li.activeTab {
  border-bottom: 3px solid #58c3bb;
  color: #000;
  font-weight: 600;
}

.subTabs {
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
}

.subTabs .subTabs-ul {
  list-style: none;
  padding-bottom: 20px;
  margin-bottom: 10px;
  display: inline-block;
  border-bottom: none;
  overflow-x: auto;
  overflow-y: hidden;
  display: -webkit-box;
  display: -moz-box;
  white-space: nowrap;
}

.subTabs .subTabs-ul li {
  display: inline;
  margin-right: 10px;
  color: #E1E1E1;
  font-size: 18px;
  font-weight: 400;
  padding-bottom: 10px;
  border-bottom: 1px solid #E1E1E1;
}

.subTabs .subTabs-ul li.activeSubTab {
  border-bottom: 2px solid #58c3bb;
  color: #58c3bb;
  font-weight: 600;
}

.subTabContainer {
  overflow-x: hidden;
  white-space: normal;
  min-height: 400px;
}

.subTabContainer .tabContent {
  display: none;
  padding: 0 !important;
}

.subTabContainer .active {
  display: block;
}

.tagsContainer .tags-tag {
  background-color: #fff;
  border: 1px solid #d1dbec;
  padding: 0px;
  font-size: 14px;
}

@media screen and (max-width: 372px) {
  .self-assesment-block-outer {
    margin-right: 5px;
  }
  .self-assesment-block {
    padding: 2px;
    margin-right: 5px;
  }
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AACA;EAAG,eAAA;EAAiB,kBAAA;EAAmB,kBAAA;AAGvC;;AAFA;EAAY,kBAAA;EAAoB,cAAA;AAOhC;;AANA;EAAQ,YAAA;AAUR;;AATA;EAAe,gBAAA;AAaf;;AAXA;EAAwB,iBAAA;EAAkB,kBAAA;EAAmB,mBAAA;AAiB7D;;AAhBA;EAA6B,eAAA;AAoB7B;;AAlBA;EAAe,kBAAA;EAAoB,WAAA;AAuBnC;;AAtBA;EAAY,YAAA;AA0BZ;;AAzBA;EAAgB,mBAAA;AA6BhB;;AA5BA;EAAoB,eAAA;AAgCpB;;AA9BA;EAAwC,qBAAA;EAAuB,WAAA;AAmC/D;;AAlCA;EAA+C,qBAAA;EAAuB,WAAA;AAuCtE;;AArCA;EAAe,0BAAA;AAyCf;;AAxCA;EAA6B,yBAAA;AA4C7B;;AA3CA;EAAiB,sBAAA;AA+CjB;;AA9CA;EAAQ,YAAA;AAkDR;;AAjDA;EAAU,gBAAA;AAqDV;;AApDA;EAAe,WAAA;AAwDf;;AAvDA;EAAgB,WAAA;AA2DhB;;AA1DA;EAAoB,uBAAA;EAAwB,sBAAA;EAAwB,kBAAA;AAgEpE;;AA/DA;EAAkB,gBAAA;AAmElB;;AAlEA;EAAyB,sBAAA;EAAwB,yBAAA;AAuEjD;;AAtEA;EAAuB,kBAAA;AA0EvB;;AAzEA;EAA0B,aAAA;AA6E1B;;AA5EA;EAAsB,cAAA;AAgFtB;;AA/EA;EAAM,WAAA;AAmFN;;AAlFA;EAAe,gBAAA;EAAiB,oBAAA;EAAqB,kBAAA;EAAmB,qBAAA;EAAsB,gCAAA;EAAiC,gBAAA;EAAiB,kBAAA;EAAmB,oBAAA;EAAqB,iBAAA;EAAkB,mBAAA;AA+F1M;;AA9FA;EAAmB,eAAA;EAAiB,kBAAA;EAAoB,cAAA;EAAe,eAAA;EAAgB,gBAAA;EAAiB,oBAAA;AAuGxG;;AAtGA;EAA4B,gCAAA;EAAgC,WAAA;EAAa,gBAAA;AA4GzE;;AA1GA;EAAS,WAAA;EAAa,mBAAA;EAAoB,gBAAA;AAgH1C;;AA/GA;EAAqB,gBAAA;EAAiB,oBAAA;EAAqB,mBAAA;EAAoB,qBAAA;EAAsB,mBAAA;EAAoB,gBAAA;EAAiB,kBAAA;EAAmB,oBAAA;EAAqB,iBAAA;EAAkB,mBAAA;AA4HpM;;AA3HA;EAAyB,eAAA;EAAgB,kBAAA;EAAmB,cAAA;EAAe,eAAA;EAAgB,gBAAA;EAAiB,oBAAA;EAAqB,gCAAA;AAqIjI;;AApIA;EAAqC,gCAAA;EAAgC,cAAA;EAAgB,gBAAA;AA0IrF;;AAzIA;EAAiB,kBAAA;EAAmB,mBAAA;EAAoB,iBAAA;AA+IxD;;AA9IA;EAA6B,aAAA;EAAe,qBAAA;AAmJ5C;;AAlJA;EAAyB,cAAA;AAsJzB;;AArJA;EAA0B,sBAAA;EAAuB,yBAAA;EAA0B,YAAA;EAAa,eAAA;AA4JxF;;AA3JA;EACI;IACI,iBAAA;EA8JN;EA3JE;IACI,YAAA;IACA,iBAAA;EA6JN;AACF","sourcesContent":["h1 {\n  font-size: 25px;\n  margin-bottom: 5px;\n  text-align: center;\n}\n\n.subHeading {\n  text-align: center;\n  color: #8a8a8a;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.fontweight600 {\n  font-weight: 600;\n}\n\n.header2 .block-limiter {\n  padding-left: 0px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n}\n\n.header2 .brandhotelselector {\n  margin-top: 5px;\n}\n\n.bellContainer {\n  position: relative;\n  width: 50px;\n}\n\n.floatRight {\n  float: right;\n}\n\n.marginBottom20 {\n  margin-bottom: 20px;\n}\n\n.calender-selection {\n  margin-top: 5px;\n}\n\n.calender-selection .control-select-men {\n  display: inline-block;\n  float: left;\n}\n\n.calender-selection .control-select-filter-men {\n  display: inline-block;\n  float: left;\n}\n\n.displayInline {\n  display: inline !important;\n}\n\n.stdcontainer .block-limiter {\n  padding: 0 10px 10px 10px;\n}\n\n.fullWidthSelect {\n  width: 100% !important;\n}\n\n.shadow {\n  width: 160px;\n}\n\n.noShadow {\n  box-shadow: none;\n}\n\n.tagsContainer {\n  float: left;\n}\n\n.iconsContainer {\n  float: left;\n}\n\n.iconsContainer svg {\n  height: 20px !important;\n  width: 20px !important;\n  margin-right: 10px;\n}\n\n.stdIconContainer {\n  margin-top: 10px;\n}\n\n.tagsContainer .tags-tag {\n  background-color: #FFF;\n  border: 1px solid #d1dbec;\n}\n\n.stdIconContainer svg {\n  margin-right: 15px;\n}\n\n.tabContainer .tabContent {\n  display: none;\n}\n\n.tabContainer .active {\n  display: block;\n}\n\n.tabs {\n  width: 100%;\n}\n\n.tabs .tabs-ul {\n  list-style: none;\n  padding-bottom: 12px;\n  margin-bottom: 0px;\n  display: inline-block;\n  border-bottom: 1px solid #F1F1F1;\n  overflow-x: auto;\n  overflow-y: hidden;\n  display: -webkit-box;\n  display: -moz-box;\n  white-space: nowrap;\n}\n\n.tabs .tabs-ul li {\n  display: inline;\n  margin-right: 10px;\n  color: #919191;\n  font-size: 18px;\n  font-weight: 400;\n  padding-bottom: 10px;\n}\n\n.tabs .tabs-ul li.activeTab {\n  border-bottom: 3px solid #58c3bb;\n  color: #000;\n  font-weight: 600;\n}\n\n.subTabs {\n  width: 100%;\n  white-space: nowrap;\n  overflow-x: auto;\n}\n\n.subTabs .subTabs-ul {\n  list-style: none;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n  display: inline-block;\n  border-bottom: none;\n  overflow-x: auto;\n  overflow-y: hidden;\n  display: -webkit-box;\n  display: -moz-box;\n  white-space: nowrap;\n}\n\n.subTabs .subTabs-ul li {\n  display: inline;\n  margin-right: 10px;\n  color: #E1E1E1;\n  font-size: 18px;\n  font-weight: 400;\n  padding-bottom: 10px;\n  border-bottom: 1px solid #E1E1E1;\n}\n\n.subTabs .subTabs-ul li.activeSubTab {\n  border-bottom: 2px solid #58c3bb;\n  color: #58c3bb;\n  font-weight: 600;\n}\n\n.subTabContainer {\n  overflow-x: hidden;\n  white-space: normal;\n  min-height: 400px;\n}\n\n.subTabContainer .tabContent {\n  display: none;\n  padding: 0 !important;\n}\n\n.subTabContainer .active {\n  display: block;\n}\n\n.tagsContainer .tags-tag {\n  background-color: #fff;\n  border: 1px solid #d1dbec;\n  padding: 0px;\n  font-size: 14px;\n}\n\n@media screen and (max-width: 372px) {\n  .self-assesment-block-outer {\n    margin-right: 5px;\n  }\n  .self-assesment-block {\n    padding: 2px;\n    margin-right: 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
